import type { CredentialResponse } from 'google-one-tap'
import type { Endpoints } from '~/types'
import type { SessionData } from '#auth'
import { useTempJWTCookie } from '~/composables/useAuthenticated'
import { signupAcquisition } from '~/utils/acquisition'

export const myFetch = $fetch.create({
  async onRequest({ options }) {
    options.baseURL = useRuntimeConfig().public.wsUrl
  },
})

export const googleRegister = async (googleJwt: string) => {
  return myFetch<Endpoints['POST__REGISTER_GOOGLE']>(
    API.POST__REGISTER_GOOGLE,
    {
      method: 'POST',
      // where the visit came from: kept only if the call creates the account
      body: { googleJwt, acquisition: signupAcquisition() },
    },
  )
}

export const getUser = async (token: string) => {
  const bearer = `Bearer ${token}`

  return myFetch<SessionData>(`/secure${API.GET__USER}`, {
    headers: {
      Authorization: bearer,
    },
  })
}

// 'signed-in': real session opened; 'temp': the sign-up form is still to fill
// (temporary session, sent to /mon-profil); 'failed': nothing changed
export type GoogleAuthResult = 'signed-in' | 'temp' | 'failed'

export const googleAuthCallback = async (
  response: CredentialResponse,
): Promise<GoogleAuthResult> => {
  try {
    if (!response.credential) {
      throw new Error('No credential found')
    }

    const { token } = await googleRegister(response.credential)

    const user = await getUser(token)

    if (!user?.birthday || !user.civility || !user.nickname || !user.lastname) {
      useTempUser().value = user
      useTempJWTCookie().value = token
      // where to come back after the finalization form (a contest, a post…)
      const from = useRouter().currentRoute.value.fullPath
      useSignupReturnTo().value = isInternalPath(from) ? from : undefined
      await useRouter().push('/mon-profil')
      return 'temp'
    }

    const { setToken, data } = useAuthState()

    setToken(token)
    data.value = user
    return 'signed-in'
  } catch (err) {
    console.error(err)
    return 'failed'
  }
}
